import type { GeolocationCoordinates } from "@Common/types/bo/applications_public/applications_public";
import { createContext, type ReactNode, useContext, useState } from "react";

type GeolocationContextValue = {
	coordinates: GeolocationCoordinates;
	setCoordinates: (value: GeolocationCoordinates) => void;
};

const GeolocationContext = createContext<GeolocationContextValue | undefined>(
	undefined,
);

export const GeolocationProvider = ({ children }: { children: ReactNode }) => {
	const [coordinates, setCoordinates] = useState<GeolocationCoordinates>(null);
	return (
		<GeolocationContext.Provider value={{ coordinates, setCoordinates }}>
			{children}
		</GeolocationContext.Provider>
	);
};

export const useGeolocation = () => {
	const ctx = useContext(GeolocationContext);
	if (!ctx)
		throw new Error("useGeolocation must be used inside GeolocationProvider");
	return ctx;
};
